import type {ProLayoutProps} from '@ant-design/pro-components';

const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  menuHeaderRender: false,
  colorWeak: false,
  // title: false, // 使用国际化标题，禁用默认标题
  title: 'Network Security',
  pwa: true,
  logo: '/icons/icon-192x192.png', // 使用项目内图标
  iconfontUrl: '',
  token: {},
};

export default Settings;
